import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { Box, IconButton, Tooltip, useTheme } from '@mui/material';
import { SxProps } from '@mui/material/styles';
import React from 'react';
import { useTranslation } from '../../../services/translation/hooks/useTranslation';
import { flexCenter } from '../../commonUI/cssClasses';
import { useColorDistributionChart } from '../hooks/useColorDistributionChart';
import ColorBucketSizeSlider from './ColorBucketSizeSlider';
import { ColorIcon } from './ColorIcon';
const ColorToolbox: React.FC = () => {
  const theme = useTheme();
  const { hideAll, showAll } = useColorDistributionChart();
  const { t } = useTranslation();

  const commonToolboxStyles: SxProps = {
    height: '100%',
    display: 'flex',
    p: '0 0.5rem',
  };

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        p: '0.3rem',
        bgcolor: theme.colors.darkTheme.grey.medium,
        color: theme.colors.common.white,
        ...flexCenter,
      }}
    >
      <Box sx={{ ...commonToolboxStyles, flexDirection: 'row' }}>
        <ColorIcon />
      </Box>
      <Box sx={{ ...commonToolboxStyles, flexDirection: 'row' }}>
        <Tooltip title={t('Show All', { ns: 'common' })}>
          <IconButton size='small' onClick={showAll}>
            <VisibilityIcon
              sx={{
                fill: (theme) => theme.colors.common.white,
              }}
            />
          </IconButton>
        </Tooltip>
      </Box>
      <Box sx={{ ...commonToolboxStyles, flexDirection: 'row' }}>
        <Tooltip title={t('Hide All', { ns: 'common' })}>
          <IconButton size='small' onClick={hideAll}>
            <VisibilityOffIcon
              sx={{
                fill: (theme) => theme.colors.common.white,
              }}
            />
          </IconButton>
        </Tooltip>
      </Box>
      <Box sx={{ ...commonToolboxStyles }}>
        <ColorBucketSizeSlider />
      </Box>
    </Box>
  );
};

export default ColorToolbox;
